

export const Environment = {
    isLocalhost: process.env.REACT_APP_ENVIRONMENT === 'local',
    backendUrl: process.env.REACT_APP_API_URL!,
}

